module.exports = __webpack_public_path__ + "static/media/miniatura_vista_compendio.5e3321b4.png";